<template>
  <div
    role="status"
    class="flex border rounded shadow border-gray-lightest animate-pulse"
    :class="{
      'flex-row gap-6 lg:gap-16': isHorizontal,
      'flex-col': isVertical,
    }"
  >
    <div
      class="flex items-center justify-center rounded bg-gray-lightest"
      :class="{
        'h-[326px] w-1/2': isHorizontal,
        'h-[210px] w-full': isVertical,
      }"
    ></div>
    <div
      class="p-4"
      :class="{
        'w-1/2': isHorizontal,
        'w-full': isVertical,
      }"
    >
      <div class="h-9.6 bg-gray-lightest rounded w-[80%] mb-4"></div>
      <div class="h-9 bg-gray-lightest rounded mb-[2px] w-full"></div>
      <div class="h-9 bg-gray-lightest rounded mb-[2px] w-full"></div>
      <div class="h-9 bg-gray-lightest rounded w-[60%] mb-4"></div>

      <div class="h-9 rounded bg-gray-lightest w-[40%]"></div>
    </div>

    <span class="sr-only">Loading...</span>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'vertical',
      validator: (value) => ['vertical', 'horizontal'].includes(value),
    },
  },
  computed: {
    isHorizontal() {
      return this.type === 'horizontal'
    },
    isVertical() {
      return this.type === 'vertical'
    },
  },
}
</script>
